import { Modal, ModalHeader, Tab, Tabs } from "@vintecc/components";
import { FC, ReactNode, useMemo, useState } from "react";

import { DebugGeneral } from "./DebugGeneral";
import { DebugRequestExplorer } from "./DebugRequestExplorer";
import { DebugTranslationExplorer } from "./DebugTranslationExplorer";
import type { DebugContextType } from "../../hooks/DebugProvider";

type DebugNavigationTab = "general" | "state-explorer";

const getDebugNavigationItems = (context: DebugContextType): (Tab & { component: ReactNode })[] => [
  {
    panelId: "general",
    title: "General",
    component: <DebugGeneral {...context} />,
  },
  {
    panelId: "request-explorer",
    title: "Request Explorer",
    component: <DebugRequestExplorer />,
  },
  {
    panelId: "translation-explorer",
    title: "Translation Explorer",
    component: <DebugTranslationExplorer />,
  },
];

export const DebugModal: FC<DebugContextType> = (context) => {
  const [debugTab, setDebugTab] = useState<DebugNavigationTab>("general");
  const debugNavigationItems = useMemo(() => getDebugNavigationItems(context), []);
  const tabIndex = useMemo(() => debugNavigationItems.findIndex((item) => item.panelId === debugTab), [debugNavigationItems, debugTab]);
  const debugContent = useMemo(() => {
    const currentTab = debugNavigationItems.find((item) => item.panelId === debugTab);
    return currentTab?.component || null;
  }, [debugNavigationItems, debugTab]);

  return (
    <Modal className="h-[calc(100vh-2rem)] w-[calc(100%-2rem)] p-4 my-4" testId="debug-modal">
      <div className="flex flex-col h-full">
        <ModalHeader testId="debug-modal-header" title="Debug Capture" />
        <nav className="px-4">
          <Tabs
            tabs={debugNavigationItems}
            activeTabIndex={tabIndex}
            defaultActiveTabIndex={0}
            onChange={(tab) => setDebugTab(tab.panelId as DebugNavigationTab)}
          />
        </nav>
        <main data-testid="debug-modal-content" className="px-4 overflow-auto flex-1 pb-4">
          {debugContent}
        </main>
      </div>
    </Modal>
  );
};
